var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1411 5093 c-60 -30 -71 -70 -71 -280 l0 -183 -186 0 c-289 0 -294 -5 -294 -295 l0 -185 -188 0 c-211 0 -240 -7 -274 -71 -17 -32 -18 -115 -18 -1992 0 -1809 1 -1962 17 -1994 9 -20 30 -44 47 -54 30 -18 83 -19 1631 -19 1587 0 1600 0 1633 20 55 34 62 66 62 275 l0 185 193 0 c286 0 287 1 287 295 l0 185 193 0 c175 0 195 2 225 20 66 41 62 -108 62 2047 0 1844 -1 1960 -18 1993 -10 20 -32 42 -52 52 -33 17 -131 18 -1625 18 -1464 0 -1593 -2 -1624 -17z m3049 -2048 l0 -1795 -105 0 -105 0 0 1638 c0 1569 -1 1639 -18 1672 -10 19 -34 43 -53 52 -32 17 -114 18 -1301 18 l-1268 0 0 105 0 105 1425 0 1425 0 0 -1795z m-480 -480 l0 -1795 -105 0 -105 0 0 1636 0 1636 -22 39 c-41 74 58 69 -1352 69 l-1266 0 0 105 0 105 1425 0 1425 0 0 -1795z m-480 -480 l0 -1795 -1425 0 -1425 0 0 1795 0 1795 1425 0 1425 0 0 -1795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 3374 c-15 -10 -22 -25 -22 -49 0 -70 -85 -65 1105 -65 963 0 1075 2 1089 16 27 26 24 71 -6 97 -19 16 -85 17 -1082 17 -945 0 -1064 -2 -1084 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 3029 c-31 -13 -40 -26 -40 -66 0 -67 -70 -63 1106 -63 1015 0 1063 1 1084 18 16 13 23 29 22 52 -2 70 82 65 -1090 67 -681 1 -1066 -2 -1082 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 2662 c-22 -25 -21 -75 1 -95 17 -16 107 -17 1089 -17 1051 0 1070 0 1088 20 22 25 22 65 0 90 -18 20 -37 20 -1090 20 -1026 0 -1073 -1 -1088 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 2314 c-33 -23 -28 -93 8 -111 20 -10 253 -13 1081 -13 1012 0 1058 1 1080 18 15 13 22 30 22 52 0 22 -7 39 -22 52 -22 17 -68 18 -1085 18 -955 0 -1064 -2 -1084 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 1954 c-22 -21 -20 -77 2 -97 17 -16 107 -17 1089 -17 1051 0 1070 0 1088 20 22 25 22 65 0 90 -18 20 -37 20 -1091 20 -962 0 -1074 -2 -1088 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 1604 c-28 -19 -30 -74 -4 -97 17 -16 107 -17 1090 -17 960 0 1072 2 1086 16 27 26 24 71 -6 97 -19 16 -85 17 -1082 17 -945 0 -1064 -2 -1084 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1259 c-31 -13 -40 -26 -40 -66 0 -67 -70 -63 1106 -63 1017 0 1063 1 1085 18 27 23 30 75 5 100 -15 16 -93 17 -1074 19 -683 1 -1066 -2 -1082 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 892 c-22 -25 -21 -75 1 -95 17 -16 83 -17 744 -17 690 0 726 1 741 18 25 27 22 78 -5 96 -20 14 -107 16 -744 16 -686 0 -722 -1 -737 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImage);
export default __webpack_public_path__ + "static/media/document_image.7e101d28f90b0558b887aeb9aede4ed3.svg";
export { ForwardRef as ReactComponent };